import { parse, ParsedQuery, stringify } from 'query-string';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { FilterableField } from 'components/organisms/tasks/fields';
import { Transformer as SearchTransformer } from 'hooks/use-search';
import {
  from_report_filter_query,
  ParsedReportFilterQuery,
  to_parsed_report_filter_query,
  to_report_filter_query,
} from './report-filter-transformer';
import { TimesheetOverallReportSearchParams } from './types';

export type ParsedOverallReportSearchParam = ParsedReportFilterQuery & {
  viewId: string | null;
};
export const toOverallReportSearchParam = ({
  viewId,
  filter,
}: TimesheetOverallReportSearchParams): ParsedOverallReportSearchParam => ({
  ...to_report_filter_query(filter),
  ...{ viewId: viewId == null || viewId === -1 ? null : viewId.toString() },
});

export const to_query = (filter: TimesheetOverallReportSearchParams): string =>
  `?${stringify(toOverallReportSearchParam(filter), { skipNull: true })}`;
export const toParsedOverallReportSearchParamsQuery = (
  query: ParsedQuery,
): Partial<ParsedOverallReportSearchParam> => ({
  ...to_parsed_report_filter_query(query),
  viewId:
    query.viewId == null
      ? null
      : typeof query.viewId === 'string'
      ? query.viewId
      : query.viewId[0],
});
export const fromOverallReportSearchParams =
  (lookup: Record<string, FilterableField>, defaultRange: DateRange) =>
  (
    query: Partial<ParsedOverallReportSearchParam>,
  ): TimesheetOverallReportSearchParams => ({
    filter: from_report_filter_query(lookup, defaultRange)(query),
    viewId:
      query.viewId == null || query.viewId === '-1'
        ? undefined
        : parseInt(query.viewId, 10),
  });
export const from_search =
  (lookup: Record<string, FilterableField>, defaultRange: DateRange) =>
  (query: string): TimesheetOverallReportSearchParams =>
    fromOverallReportSearchParams(
      lookup,
      defaultRange,
    )(toParsedOverallReportSearchParamsQuery(parse(query)));

export const getTimesheetOverallReportSearchParamTransformer = (
  lookup: Record<string, FilterableField>,
  defaultRange: DateRange,
): SearchTransformer<TimesheetOverallReportSearchParams> => ({
  from: (parsed) =>
    fromOverallReportSearchParams(
      lookup,
      defaultRange,
    )(toParsedOverallReportSearchParamsQuery(parsed)),
  to: toOverallReportSearchParam,
});
